// 新闻页数据
export const newList = [
    {
      id: 1,
      title: 'Voyage Shortlisted by MTN Group as OpenRAN Supplier',
      time: '16 June 2021',
      content:
        'MTN Group is leveraging our expansive footprint across Africa to test and ultimately deploy OpenRAN – an innovative  technology that will enable us to launch new services more quickly, cost-effectively and seamlessly, supporting our strategy, Ambition 2025: Leading digital solutions for Africa’s progress.'
    },
    {
      id: 2,
      title:
        'MTN Group Empowers Entrepreneurs with Launch of “21 Days of Y’ello Care”',
      time: '02 June 2023',
      content:
        'MTN Group today announced the launch of its highly anticipated 21 Days of Y’ello Care campaign, set to run from 1 to 21 June 2023. This year’s campaign focuses on “Empowering entrepreneurs to unlock growth and job creation for communities.”'
    },
    {
      id: 3,
      title:
        'MTN launches SME Day, with an aim of empowering over 40 million small businesses across the African continent',
      time: '23 May 2023',
      content:
        'MTN, Africa’s leading telecommunications company, is thrilled to announce its upcoming SME hybrid event aimed at fostering growth and providing essential resources to the continent’s small and medium-sized enterprises (SMEs). The two-day event, featuring a combination of physical and online components, will bring together industry experts, inspirational thought leaders, and innovative solutions to support the success of African businesses.'
    },
    {
      id: 4,
      title:
        'MTN Zambia Launches Skills Academy to Empower Youth and Bridge Digital Skills Gap',
      time: '25 April 2023',
      content:
        'MTN Group today announced the launch of its flagship MTN Skills Academy in Zambia, the first of its operations to roll out this initiative which is aimed at addressing the digital skills gap in Africa. First introduced at MWC  in Kigali,  the MTN Skills Academy is a free, online learning platform that will see MTN play its role to actively drive digital skills development and job creation across Africa and have at least 60% of youth and adults on our markets having at least a minimum level of proficiency in sustainable digital skills by 2025.'
    },
    {
      id: 5,
      title: 'MTN Zambia launches the country’s first 5G network',
      time: '24 November 2022',
      content:
        'MTN Zambia today launched our 5G network, becoming the first mobile operator in Zambia to offer 5G services commercially after successfully undertaking trials of the transformative technology over the past 11 months.'
    },
    {
      id: 6,
      title: 'MTN launches Anywhere, Anytime flexible work policy',
      time: '07 February 2022',
      content:
        'MTN Group is pleased to announce the introduction of Anywhere, Anytime Flexibility, a new Group Policy that encourages time and place flexibility. Under the auspices of the Group’s future focussed “Live Inspired” employee value proposition that was introduced in 2021, Anywhere, Anytime Flexibility aims to better reflect the changing nature of the way we work. The policy enables qualifying employees with Anytime flexibility which relates to usage of business hours and Anywhere flexibility which relates to usage of workspaces.'
    },
    {
      id: 7,
      title:
        'MTN Group and Rakuten Symphony sign a MoU to conduct 4G and 5G OpenRAN trials in SA, Nigeria & Liberia',
      time: '03 March 2022',
      content:
        'MTN Group and Rakuten Symphony have signed a Memorandum of Understanding (MoU) to conduct live 4G and 5G OpenRAN Proof of Concept (PoC) trials in South Africa, Nigeria, and Liberia based on Rakuten Communications Platform (RCP). RCP assists telcos worldwide with the deployment of fully cloud-native network services.'
    }
  ]
